interface JsonLDProps {
  data: Record<string, unknown> | Record<string, unknown>[];
}

export default function JsonLD({ data }: JsonLDProps) {
  const dataArray = Array.isArray(data) ? data : [data];
  const jsonString = JSON.stringify(
    dataArray.length === 1 ? dataArray[0] : dataArray,
    null,
    0
  );

  return <script type="application/ld+json">{jsonString}</script>;
}